import { FC, memo } from 'react';

import Heading from './Heading';
import { HeadingProps, HxType } from './type';

const Heading1: FC<HeadingProps> = props => <Heading {...props} type={HxType.H1} />;
const Heading2: FC<HeadingProps> = props => <Heading {...props} type={HxType.H2} />;
const Heading3: FC<HeadingProps> = props => <Heading {...props} type={HxType.H3} />;
const Heading4: FC<HeadingProps> = props => <Heading {...props} type={HxType.H4} />;

export const H1 = memo(Heading1);
export const H2 = memo(Heading2);
export const H3 = memo(Heading3);
export const H4 = memo(Heading4);
